import React, { Fragment } from 'react';
import styled from '@emotion/styled';

import SpinnerBlock from '../../../../common/SpinnerBlock';
import TableRow from './TableRow';

const Wrapper = styled('div')`
  margin-top: 24px;
  .table {
    width: 100%;
    margin-bottom: 0;
    .tr-no-border td {
      border: none;
    }
    .bolder {
      font-weight: 700;
    }
  }
  .table tr {
    padding-top: 3px;
    padding-bottom: 3px;
    color: #323a46;
  }
  .table th {
    &.right {
      text-align: right;
    }
  }
  .table td {
    padding-bottom: 7px;
    padding-top: 7px;
    &.right {
      text-align: right;
    }
  }
  .table .thead-light th {
    padding-top: 9px;
    padding-bottom: 9px;
    span {
      font-weight: 500;
    }
  }
  strong {
    display: block;
    font-weight: 500;
  }
  .text-muted {
    color: #98a6ad;
  }
  .red {
    color: #f1556c;
  }
`;

const SeparationRow = styled('tr')`
  height: 48px;
  background: #fafafa;

  .light {
    color: #98a6ad;
  }

  strong {
    font-weight: 700;
  }

  .large {
    font-size: 16px;
  }
`;

const THEAD_ITEMS = [
  {
    title: 'Услуга',
    align: 'left',
    colSpan: 1,
  },
  {
    title: 'Цена',
    align: 'right',
    colSpan: 3,
  },
  {
    title: 'Ед.',
    align: 'left',
    colSpan: 1,
  },
];

const MainTable = (props) => {
  const { loading, items } = props;

  return (
    <>
      <Wrapper>
        <div className="fixed-table-container mb-3">
          <div className="fixed-table-body">
            <table className="table table-centered">
              <thead className="thead-light">
                <tr>
                  <Fragment>
                    {THEAD_ITEMS.map((item) => (
                      <th
                        className={item.align === 'right' ? 'right' : null}
                        colSpan={item.colSpan}
                      >
                        {item.title}
                      </th>
                    ))}
                  </Fragment>
                </tr>
              </thead>
              {!loading ? (
                <tbody>
                  {items.map((item) => (
                    <>
                      <SeparationRow>
                        <td colSpan="5">
                          <strong className="large">{item.category}</strong>
                        </td>
                      </SeparationRow>
                      {item.items?.map((item) => (
                        <TableRow item={item} key={item.id} />
                      ))}
                    </>
                  ))}
                </tbody>
              ) : null}
            </table>
            {loading ? (
              <div style={{ width: '100%', position: 'relative', height: '150px ' }}>
                <SpinnerBlock show={loading} />
              </div>
            ) : null}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default MainTable;
